import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import ElementUI from 'element-ui'
import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
import VueMobileDetection from 'vue-mobile-detection'

Vue.config.productionTip = false

Axios.interceptors.request.use((requestconfig) => {
    const token = localStorage.getItem('token')
    if (token) requestconfig.headers.common['Authorization'] = token
    return requestconfig;
})
Axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status == 401) router.push('/login')
    return Promise.reject(error)
})

Vue.prototype.$http = Axios


Vue.use(ElementUI, { locale: ruLocale })
Vue.use(VueMobileDetection)

new Vue({
    router: router,
    store: store,
    render: h => h(App),
}).$mount('#app')


import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap'
